const LEGACY_BY_FOOT_PER_MONTH = "by_foot_per_month"
const LEGACY_SQFT_PER_MONTH = "sqft_per_month"

export const normalizePricingStructure = ({ pricingStructure }) => {
  // this is necessary until the UI offers a length unit selection option rather than the
  // legacy hardcoded `foot` and `sqft` pricing structures. UI changes will be necessary
  // once we support meters, but since there are no concrete plans to do so, we can continue
  // to leverage the legacy values in the UI and transform them here on submission
  switch (pricingStructure) {
    case LEGACY_BY_FOOT_PER_MONTH:
      return {
        pricingStructure: "by_length_per_month",
        lengthUnit: "foot",
      }
    case LEGACY_SQFT_PER_MONTH:
      return {
        pricingStructure: "by_area_per_month",
        lengthUnit: "foot",
      }
    default:
      return {
        pricingStructure,
        lengthUnit: null,
      }
  }
}
